import 'browsernizr/test/css/flexbox';
import 'browsernizr/test/css/flexwrap';
import 'browsernizr/test/css/pointerevents';
import Modernizr from 'browsernizr';

function isTouchDevice() {
  return !(window.screen.width > 1400 || window.screen.width < 1400 &&
    window.innerWidth < .9 * window.screen.width) &&
    ('ontouchstart' in document.documentElement);
}

function isFlexboxAvailable() {
  return Modernizr.flexbox || Modernizr.flexwrap;
}

function isPointerEventsAvailable() {
  return Modernizr.csspointerevents;
}

function isKeyboardClick(e) {
  return e.screenX === 0 && e.screenY === 0;
}

function isAppleDevice() {
  return /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export {
  isAppleDevice,
  isFlexboxAvailable,
  isPointerEventsAvailable,
  isTouchDevice,
  isKeyboardClick,
};
